import React, { useEffect, useState } from 'react';
import { api } from '../api.js';
import { errMessage } from '../i18n.js';
import { useT, useDateFmt } from '../lang.js';
import Icon from '../Icon.jsx';
import PageSkeleton from '../Skeleton.jsx';

/**
 * Offline cihazın uygulanamayan niyetleri.
 *
 * Bu ekranın varlık sebebi: senkron bir niyeti uygulayamadığında SESSİZCE
 * YUTMUYORUZ. Garsonun offline aldığı sipariş kapanmış hesaba düşerse birisi
 * bunu görmek zorunda — yoksa yemek çıkar, hesap yoktur.
 */
export default function Conflicts() {
  const t = useT();
  const fmt = useDateFmt();
  const [list, setList] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const load = () => api('/api/sync/conflicts').then(setList).catch((e) => setErr(errMessage(t, e)));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  if (err && !list) return <p className="err">{err}</p>;
  if (!list) return <PageSkeleton shape="table" />;

  async function resolve(id, status) {
    setBusy(true);
    try { await api(`/api/sync/conflicts/${id}/resolve`, { method: 'POST', body: { status } }); await load(); }
    catch (e) { setErr(errMessage(t, e)); }
    finally { setBusy(false); }
  }

  return (
    <div className="card">
      <div className="row">
        <h2 style={{ margin: 0 }}>{t('sync.title')}</h2>
        <span className="spacer" />
        <button onClick={load} disabled={busy}><Icon n="refresh" />{t('refresh')}</button>
      </div>
      {list.length === 0 && <p className="muted">{t('sync.empty')}</p>}
      {list.map((c) => (
        <div className="card" key={c.id} style={{ borderColor: 'var(--warn)' }}>
          <div className="row">
            <b>{t(`sync.kind.${c.intentKind}`)}</b>
            <span className="badge warn">{t(`sync.reason.${c.reason}`)}</span>
            <span className="muted" style={{ fontSize: 12 }}>
              {c.device?.label || t('sync.unknownDevice')} · {fmt.dateTime(c.createdAt)}
            </span>
          </div>
          {c.payloadJson && (
            <pre className="muted" style={{ fontSize: 12, overflowX: 'auto', margin: '8px 0' }}>
              {JSON.stringify(c.payloadJson, null, 1)}
            </pre>
          )}
          <div className="row">
            <button disabled={busy} onClick={() => resolve(c.id, 'RESOLVED')}>
              <Icon n="checkCircle" />{t('sync.handled')}
            </button>
            <button disabled={busy} onClick={() => resolve(c.id, 'DISCARDED')}>
              <Icon n="trash" />{t('sync.discard')}
            </button>
          </div>
        </div>
      ))}
      <p className="muted" style={{ marginBottom: 0 }}>{t('sync.note')}</p>
    </div>
  );
}
